import { Component, ViewChild, TemplateRef, Input } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
    selector: "metadata-modal",
    templateUrl: "./metadatamodal.component.html",
    standalone: false
})
export class MetadataModalComponent {
    @Input() metadatas!: any[];

    showLoading: boolean = true;
    private auditHistory: any;

    constructor(private modalService: BsModalService) { }

    @ViewChild("metadata") metadataModal!: TemplateRef<any>;
    modalInstance!: BsModalRef;

    /*
     * Initializes the modal
     */
    // tslint:disable-next-line:no-empty
    ngOnInit(): void {
    }

    open(): void {
        this.showLoading = true;
        this.modalInstance = this.modalService.show(this.metadataModal, { "class": "modal-md" });
    }
}

